import "./StudentAchievementsStories.module.css";
import Header from "@/reusable_sections/Header";
import Highlights from "./sections/Highlights";
import TechnicalShowcase from "./sections/TechnicalShowcase";
import Stories from "./sections/Stories";
import Champions from "./sections/Champions";
import Footer from "@/reusable_sections/Footer";
export default function StudentAchievementsStoriesPage() {
  return <div>
      <Header />
      <Highlights />
      <TechnicalShowcase />
      <Stories />
      <Champions />
      <Footer />
    </div>;
}